import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useAuthOrigin } from './useAuthOrigin'

type Options = {
  refreshToken: string
  clientId: string
}

export function useRevokeToken() {
  const $httpFetch = useHttpFetch()

  async function revokeToken(options: Options) {
    const body = new URLSearchParams({
      client_id: options.clientId,
      token: options.refreshToken,
      token_type_hint: 'refresh_token',
    })

    return $httpFetch('/oauth2/revoke', {
      method: 'POST',
      baseURL: useAuthOrigin(),
      body,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    })
  }

  return { revokeToken }
}
